import { render, staticRenderFns } from "./sequence.vue?vue&type=template&id=5f48f33f&"
import script from "./sequence.vue?vue&type=script&lang=js&"
export * from "./sequence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports